export default (state, payload) => {
  state.shappy.user_info = payload
}



// WEBPACK FOOTER //
// ./src/store/modules/shappy/mutations/setShappyInfo.js